import { ITypeInventory } from "api/types/_inventory";
import {
    CONFIG_OPTION_TOAST_ERROR,
    CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Col, Input, Row, Spinner } from "reactstrap";
import { getTypeInventory, postTypeInventory, putTypeInventory } from "store/thunks";
import * as Yup from "yup";


export interface Props {
    isModal?: boolean;
    id?: number;
    detail?: ITypeInventory | null;
    triggerRefresh?: () => void;
    handleClose?: () => void;
}

const FormTypeInventory = ({
    detail,
    triggerRefresh,
    handleClose,
}: Props) => {
    const { t, i18n } = useTranslation();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleSubmit = async (values: any) => {
        try {
            setIsLoading((_prev) => true);

            const data = {
                title: values?.title || '',
                title_kr: values?.title || '',
            };
            const response: any = detail?.id
                ? await putTypeInventory(detail?.id, data)
                : await postTypeInventory(data);
            if (response?.code === 200) {
                setIsLoading((_prev) => false);
                toast(
                    `${t("The process has been completed.")}`,
                    CONFIG_OPTION_TOAST_NORMAL
                );
                triggerRefresh && triggerRefresh();
            } else {
                setIsLoading((_prev) => false);
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsLoading((_prev) => false);
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const validationSchema = Yup.object({
        title: Yup.string().required(`${t("This is required")}`),
        title_kr: Yup.string().nullable(),
    });

    const formik = useFormik({
        initialValues: {
            title: '',
            title_kr: '',
        },
        validationSchema,
        onSubmit: handleSubmit,
    });

    const handleSetValueForm = (valueDefault: any) => {
        const v_title = valueDefault?.title || '';
        const v_title_kr = valueDefault?.title_kr || '';

        formik.setFieldValue("title", v_title);
        // formik.setFieldValue("title_kr", v_title_kr);
    };

    useEffect(() => {
        setTimeout(() => {
            formik.setErrors({});
        }, 300);
        if (detail?.id) {
            handleSetValueForm(detail);
            const getDetail = async () => {
                try {
                    const response: any = await getTypeInventory(detail?.id);
                    if (response?.code === 200) {
                        const cloneInventory: any = structuredClone(response?.data);
                        handleSetValueForm(cloneInventory);
                    } else {
                        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
                    }
                } catch (error: any) {
                    toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
                    return error;
                }
            }
            getDetail();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [detail]);


    return (
        <React.Fragment>
            <form onSubmit={formik.handleSubmit}>
                <Row>
                    <Col lg={12}>
                        <div id="leadsList">
                            <div className="pt-0">
                                <div className="mt-2">
                                    <Col sm={12} className="mt-0">
                                        <div
                                            className="row g-3"
                                            style={{
                                                backgroundColor: "var(--vz-light)",
                                                padding: "10px 10px 20px",
                                                borderRadius: "5px",
                                            }}
                                        >
                                            {/* <Col md={12} lg={12} className="mt-2">
                                                <div>
                                                    <label className="form-label">
                                                        {t("Title (Korea)")} <span className="text-danger"> *</span>
                                                    </label>
                                                    <Input
                                                        type="text"
                                                        id="title_kr"
                                                        name="title_kr"
                                                        autocomplete={false}
                                                        value={formik?.values?.title_kr}
                                                        placeholder={`${t("Title (Korea)")}...`}
                                                        onChange={(event: any) =>
                                                            formik.setFieldValue(
                                                                "title_kr",
                                                                event?.target?.value || ""
                                                            )
                                                        }
                                                    />
                                                    {formik.touched.title_kr && formik.errors.title_kr ? (
                                                        <div className="text-danger mt-2">
                                                            {formik.errors.title_kr}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Col> */}
                                            <Col md={12} lg={12} className="mt-2">
                                                <div>
                                                    <label className="form-label">
                                                        {t("Title Type")} <span className="text-danger"> *</span>
                                                    </label>
                                                    <Input
                                                        type="text"
                                                        id="title"
                                                        name="title"
                                                        autocomplete={false}
                                                        value={formik?.values?.title}
                                                        placeholder={`${t("Title Type")}...`}
                                                        onChange={(event: any) =>
                                                            formik.setFieldValue(
                                                                "title",
                                                                event?.target?.value || ""
                                                            )
                                                        }
                                                    />
                                                    {formik.touched.title && formik.errors.title ? (
                                                        <div className="text-danger mt-2">
                                                            {formik.errors.title}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Col>

                                            <Col lg={12}>
                                                <div className="hstack gap-2 justify-content-sm-center justify-content-md-end mt-3">
                                                    <button
                                                        className="btn btn-soft-secondary rounded-pill fs-14 me-2"
                                                        color="light"
                                                        type="button"
                                                        disabled={isLoading}
                                                        style={{ width: "100px" }}
                                                        onClick={() => {
                                                            handleClose && handleClose();
                                                        }}
                                                    >
                                                        {t("Button Close")}
                                                    </button>
                                                    {!detail?.is_preview && (
                                                        <button
                                                            className="btn btn-primary rounded-pill fs-14"
                                                            color="success"
                                                            type="submit"
                                                            disabled={isLoading}
                                                            style={{ width: detail?.id ? "190px" : "170px" }}
                                                        >
                                                            {isLoading ? (
                                                                <Spinner size="sm" className="me-2"></Spinner>
                                                            ) : (
                                                                <>
                                                                    {detail?.id
                                                                        ? t("Button Update Type Inventory")
                                                                        : t("Button Create Type Inventory")}
                                                                </>
                                                            )}
                                                        </button>
                                                    )}
                                                </div>
                                            </Col>
                                        </div>
                                    </Col>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </form>
        </React.Fragment>
    );
};

export default FormTypeInventory;
